import { RootState } from "@redux/rootReducer";
import { useSelector } from "react-redux";

export default function useStaffList() {
  const staffList = useSelector((state: RootState) => state.staffs.bdStaffData);

  return staffList;
}
